//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isRichtextFilled } from '~/utils/helpers';

export default {
  name: 'BlokInfoDocuments',
  props: {
    blok: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
  },
  computed: {
    heading() {
      switch(this.index) {
        case 0:
          return 'h1';
        default:
          return 'h2';
      }
    },
    headingSubtitle() {
      if (this.blok.title) {
        return this.heading === 'h1' ? 'h2' : 'h3';
      }

      return this.heading;
    },
  },
  methods: {
    isRichtextFilled(doc) {
      return isRichtextFilled(doc);
    },
  },
};
